var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sky-line-text"},[_c('div',{staticClass:"sky-line"},[_c('div',{staticClass:"line-title"},[_vm._v("\n      "+_vm._s(_vm.data)+"\n    ")]),_c('div',{staticClass:"line-icon",style:({
        display: _vm.hideIcon
      }),on:{"click":_vm.compile}},[_c('ig-icon',{attrs:{"name":"bianji1"}})],1)]),_c('div',{staticClass:"line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }